/**
 * Warehouse and pickup constants
 */

// ID used to identify pickup orders in the address selection
export const PICKUP_ADDRESS_ID = "PICKUP";

// Warehouse address information for pickup orders
export const WAREHOUSE_ADDRESS = {
  name: "Bodega D",
  street: "Caupolicán 9261",
  number: "",
  city: "Quilicura",
  comuna: "Quilicura",
  region: "Región Metropolitana",
  postalCode: "8710042",
  country: "Chile",
} as const;

// Helper function to get pickup complement text
export const getPickupComplement = () =>
  `${WAREHOUSE_ADDRESS.name} - Cliente retira en bodega`;

// Full warehouse address formatted for display
export const getWarehouseFullAddress = () =>
  `${WAREHOUSE_ADDRESS.street}, ${WAREHOUSE_ADDRESS.comuna}, ${WAREHOUSE_ADDRESS.region}, ${WAREHOUSE_ADDRESS.country}`;
